import {BaseStore, globalStore} from "../../../../stem-core/state/Store";
import {field} from "../../../../stem-core/state/StoreField.js";
import {apiClient} from "../../../connection/BlinkApiClient.js";

@globalStore
export class MerchantCDSPromoKeys extends BaseStore("MerchantCDSPromoKeys") {
    @field("Merchant") merchant: any;
    @field("MerchantCDSProduct") product: any;
    @field("SubscriptionOffer") subscriptionOffer: any;
    @field(Array) promoKeys: string[];
    @field(Boolean) allowUnverified: boolean;
}

export async function apiMerchantEditCDSPromoKeys(request: any): Promise<any> {
    return apiClient.post("/external_providers/edit_cds_promo_keys/", request);
}